export default __webpack_public_path__ + "static/2-sexy-map-sattelite-4fe2015f3bec755539e09cb95b8c98f5.png";